export function emptyError(field) {
      if(field.value === '') {
        field.error = true
        return field
      } else {
        field.error = false
        return field
      }
}


// WEBPACK FOOTER //
// ./src/utils/emptyError.js